.noData {
  margin: 1.5rem;
  display: flex;
  justify-content: center;
}

.scrollWrapper {
  overflow-y: auto;
  overflow-x: hidden;
}

.tableWrapper {
  border-radius: 32px;
  overflow: hidden;
}

.table {
  width: 100%;
  table-layout: fixed;
  border-spacing: 0;
  border-collapse: collapse;
  position: relative;
  font:
    normal normal 300 1.0625rem/1.4375rem Roboto,
    sans-serif;
}

.thead {
  background-color: var(--color-ffffff);
  color: var(--text);
  font:
    normal normal bold 1.1875rem/1.5625rem Roboto,
    sans-serif;
  letter-spacing: 0.38px;
}

.td {
  padding: 8px;
  overflow: hidden;
}

.tbody {
  max-height: 100%;
  overflow-y: scroll;
}

.queryTableFilterWrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.tr {
  background: rgba(255, 255, 255, 0.7);
  transition: 0.3s;
}

.tr:hover {
  background: rgba(127, 127, 255, 0.5);
}

.tr:not(:first-of-type) {
  border-top: 1px solid gray;
}

.middle {
  align-items: center;
  display: flex;
  margin-right: 5px;
}

.headerWrapper {
  display: flex;
  align-items: center;
  padding: 8px;
}

.headerTitle {
  padding-left: 10px;
}

.sortWrapper {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  font-size: 1rem;
  line-height: 1rem;
}

.noSort {
  color: transparent !important;
}

.sort {
  text-align: center;
  cursor: pointer;
  color: gray;
}

.sortActive {
  color: var(--secondary-100);
}

.right {
  display: flex;
  justify-content: flex-end;
  margin-right: 15px;
  align-items: center;
}

.thead > *:first-child,
.tr > *:first-child {
  padding-left: 40px;
}

.thead > *:last-child,
.tr > *:last-child {
  padding-right: 40px;
}
